import { Unit } from '../../layout/constants'

const measureTextCanvas = document.createElement('canvas')
const measureTextContext = measureTextCanvas.getContext('2d')

export function measureText(text, font) {
  measureTextContext.font = font
  return measureTextContext.measureText(text)
}

const measureFontCanvas = document.createElement('canvas')
const measureFontContext = measureTextCanvas.getContext('2d')
const measureFontCache = {}

/**
 * String used for calculate font metrics.
 * These characters are all tall to help calculate the height required for text.
 */
const METRICS_STRING = '|ÉqÅ'

/**
 * Baseline symbol for calculate font metrics.
 */
const BASELINE_SYMBOL = 'M'

/**
 * Baseline multiplier for calculate font metrics.
 */
const BASELINE_MULTIPLIER = 1.4

/**
 * Calculates the ascent, descent and fontSize of a given font-style
 *
 * @static
 * @param {string} font - String representing the style of the font
 * @return {PIXI.IFontMetrics} Font properties object
 */
export function measureFont(font) {
  // as this method is used for preparing assets, don't recalculate things if we don't need to
  if (measureFontCache[font]) {
    return measureFontCache[font]
  }

  const properties = {}

  const canvas = measureFontCanvas
  const context = measureFontContext

  context.font = font

  const metricsString = METRICS_STRING + BASELINE_SYMBOL
  const width = Math.ceil(context.measureText(metricsString).width)
  let baseline = Math.ceil(context.measureText(BASELINE_SYMBOL).width)
  const height = 2 * baseline

  baseline = (baseline * BASELINE_MULTIPLIER) | 0

  canvas.width = width
  canvas.height = height

  context.fillStyle = '#f00'
  context.fillRect(0, 0, width, height)

  context.font = font

  context.textBaseline = 'middle'
  context.fillStyle = '#000'
  context.fillText(metricsString, 0, baseline)

  const imagedata = context.getImageData(0, 0, width, height).data
  const pixels = imagedata.length
  const line = width * 4

  let i = 0
  let idx = 0
  let stop = false

  // ascent. scan from top to bottom until we find a non red pixel
  for (i = 0; i < baseline; ++i) {
    for (let j = 0; j < line; j += 4) {
      if (imagedata[idx + j] !== 255) {
        stop = true
        break
      }
    }
    if (!stop) {
      idx += line
    } else {
      break
    }
  }

  properties.ascent = baseline - i

  idx = pixels - line
  stop = false

  // descent. scan from bottom to top until we find a non red pixel
  for (i = height; i > baseline; --i) {
    for (let j = 0; j < line; j += 4) {
      if (imagedata[idx + j] !== 255) {
        stop = true
        break
      }
    }

    if (!stop) {
      idx -= line
    } else {
      break
    }
  }

  properties.descent = i - baseline
  properties.fontSize = properties.ascent + properties.descent
  properties.baselineOffset = (properties.ascent - properties.descent) / 2

  measureFontCache[font] = properties

  return properties
}

export function calculateLineHeight(style) {
  const lineHeight = style.lineHeight
  return lineHeight.unit === Unit.PX
    ? lineHeight.value
    : (lineHeight.value * style.fontSize.value) / 100
}

export const resolutionsSteps = [1, 0.5, 0.25, 0.125, 0.0625]

export const selectResolutionIndex = (scale) => {
  let i
  for (i = 0; i < resolutionsSteps.length - 1; i++) {
    if (scale >= resolutionsSteps[i + 1]) {
      return i
    }
  }

  return i
}
